import React, { useEffect, useMemo } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import ClaimsSearchBar from "../components/ClaimsSearchBar.jsx";
import ClaimsTable from "../components/tables/ClaimsTable.jsx";
import NotificationsTable from "../components/tables/NotificationsTable.jsx";
import HomeSubstitutionsCard from "../components/HomeSubstitutionsCard.jsx";
import { useAtomValue } from "jotai";
import { notificationAtom } from "../atoms/notificationAtom.js";

function getUnreadCount(notifications) {
  if (!Array.isArray(notifications)) {
    return 0;
  }

  return notifications.filter((notification) => !notification?.seen_at).length;
}


export function HomePage() {
  const { setBreadcrumbs } = useBreadcrumb();

  const notifications = useAtomValue(notificationAtom);

  const notificationCount = useMemo(
    () => getUnreadCount(notifications),
    [notifications]
  );

  useEffect(() => {
    setBreadcrumbs([{ name: "Home", path: "/home" }]);
  }, [setBreadcrumbs]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <Box>
        <Typography variant="h1" sx={{ mb: 1 }}>
          Meine Übersicht
        </Typography>
      </Box>

      {/* Search and Create */}
      <ClaimsSearchBar />

      {/* Cards Section */}
      <Grid container spacing={3}>
        <Grid item size={{ md: 7, xs: 12 }}>
          <NotificationsTable enableTopToolbar={false} totalCount={notificationCount} />
        </Grid>

        <Grid item size={{ md: 5, xs: 12 }}>
          <HomeSubstitutionsCard title="Meine Vertretungen" />
        </Grid>

        <Grid item size={{ xs: 12 }}>
          <ClaimsTable variant="compact" limit={5} />
        </Grid>
      </Grid>
    </Box>
  );
}
